import { Search } from 'lucide-react'
import TextField from './common/TextField'

interface SearchBarProps {
  placeholder?: string
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const SearchBar = ({ placeholder = 'Search...', value, onChange }: SearchBarProps) => {
  return (
    <TextField
      placeholder={placeholder}
      icon={<Search className="w-4 h-4 lg:w-5 lg:h-5 text-text-secondary" />}
      iconPosition="left"
      value={value}
      onChange={onChange}
    />
  )
}

export default SearchBar
